import { Component } from '@theme/component';

/**
 * Keeps the category browser expanded on desktop and collapsible on mobile.
 * @extends {Component<{browser: HTMLDetailsElement}>}
 */
class CollectionSidebar extends Component {
  requiredRefs = ['browser'];
  desktop = matchMedia('(min-width:990px)');

  connectedCallback() {
    super.connectedCallback();
    this.syncViewport();
    this.desktop.addEventListener('change', this.syncViewport);
  }

  updatedCallback() {
    super.updatedCallback();
    this.syncViewport();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.desktop.removeEventListener('change', this.syncViewport);
  }

  syncViewport = () => {
    this.refs.browser.open = this.desktop.matches;
  };
}

if (!customElements.get('bn-collection-sidebar')) customElements.define('bn-collection-sidebar', CollectionSidebar);
